export default __webpack_public_path__ + "static/roundwalls-8cb34d029b40ba059cd633b18cb7e139.png";